import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import {
  IDeleteDataResponseAndPayload,
  TResponse,
  TResponseWithQData,
} from "../../../types/common";
import {
  IPurchaseOrder,
  IPOCreatePayload,
  IPOUpdatePayload,
  IPOStatusPayload,
  IPOCancelPayload,
} from "../../../types/api/purchase-order";

export async function listPO(
  qData: QData,
): Promise<AxiosResponse<TResponseWithQData<IPurchaseOrder[]>>> {
  return axios.get(API_ENDPOINTS.PO_LIST, { params: qData });
}

export async function poDetail(
  id: string | number,
): Promise<AxiosResponse<TResponse<IPurchaseOrder>>> {
  return axios.get(`${API_ENDPOINTS.PO_DETAIL}/${id}`);
}

export async function createPO(
  data: IPOCreatePayload,
): Promise<AxiosResponse<TResponse<IPurchaseOrder>>> {
  return axios.post<TResponse<IPurchaseOrder>>(API_ENDPOINTS.PO_CREATE, data);
}

export async function updatePO(
  data: IPOUpdatePayload,
): Promise<AxiosResponse<TResponse<IPurchaseOrder>>> {
  return axios.post<TResponse<IPurchaseOrder>>(API_ENDPOINTS.PO_UPDATE, data);
}

export async function deletePO(
  data: IDeleteDataResponseAndPayload,
): Promise<AxiosResponse<TResponse<IDeleteDataResponseAndPayload>>> {
  return axios.post<TResponse<IDeleteDataResponseAndPayload>>(
    API_ENDPOINTS.PO_DELETE,
    data,
  );
}

export async function updatePOStatus(
  data: IPOStatusPayload,
): Promise<AxiosResponse<TResponse<IPurchaseOrder>>> {
  return axios.post<TResponse<IPurchaseOrder>>(API_ENDPOINTS.PO_STATUS, data);
}

export async function cancelPO(
  data: IPOCancelPayload,
): Promise<AxiosResponse<TResponse<IPurchaseOrder>>> {
  return axios.post<TResponse<IPurchaseOrder>>(API_ENDPOINTS.PO_CANCEL, data);
}

export async function generatePOShareLink(
  id: number,
): Promise<AxiosResponse<TResponse<{ token: string }>>> {
  return axios.post<TResponse<{ token: string }>>(
    `${API_ENDPOINTS.PO_SHARE}/${id}/share`,
  );
}
